/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { FlexDTO } from '../model/flexDTO';
// @ts-ignore
import { MessagesBodyDTO } from '../model/messagesBodyDTO';
// @ts-ignore
import { PaginatedSpaGateEventDTO } from '../model/paginatedSpaGateEventDTO';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class GateService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Checks if the given user may enter the SPA area. If not, the message body may give hints on user interaction to buy an adhoc ticket. 
     * @endpoint post /rest/v1/spa/area/{boardcardNumber}/enter
     * @param boardcardNumber The guest card BoardcardNumber.
     * @param idempotencyKey indicates if a flex ticket should be booked if there is no ticket yet
     * @param flex indicates if a flex ticket should be booked if there is no ticket yet
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public enterSpaArea(boardcardNumber: string, idempotencyKey?: string, flex?: FlexDTO, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MessagesBodyDTO>;
    public enterSpaArea(boardcardNumber: string, idempotencyKey?: string, flex?: FlexDTO, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MessagesBodyDTO>>;
    public enterSpaArea(boardcardNumber: string, idempotencyKey?: string, flex?: FlexDTO, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MessagesBodyDTO>>;
    public enterSpaArea(boardcardNumber: string, idempotencyKey?: string, flex?: FlexDTO, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (boardcardNumber === null || boardcardNumber === undefined) {
            throw new Error('Required parameter boardcardNumber was null or undefined when calling enterSpaArea.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'idempotencyKey',
            <any>idempotencyKey,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'flex',
            <any>flex,
            QueryParamStyle.Form,
            false,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (sessionAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('sessionAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/v1/spa/area/${this.configuration.encodeParam({name: "boardcardNumber", value: boardcardNumber, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/enter`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MessagesBodyDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Checks if the user left the area in time. If not, an adhoc ticket will be booked. 
     * @endpoint post /rest/v1/spa/area/{boardcardNumber}/leave
     * @param boardcardNumber The guest card BoardcardNumber.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public leaveSpaArea(boardcardNumber: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MessagesBodyDTO>;
    public leaveSpaArea(boardcardNumber: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MessagesBodyDTO>>;
    public leaveSpaArea(boardcardNumber: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MessagesBodyDTO>>;
    public leaveSpaArea(boardcardNumber: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (boardcardNumber === null || boardcardNumber === undefined) {
            throw new Error('Required parameter boardcardNumber was null or undefined when calling leaveSpaArea.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (sessionAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('sessionAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/v1/spa/area/${this.configuration.encodeParam({name: "boardcardNumber", value: boardcardNumber, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/leave`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MessagesBodyDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retuns the SPA gate events (enter/leave) that match the given query parameters. 
     * @endpoint get /rest/v1/spa/area/events
     * @param query the query search term.
     * @param fromDate Restricts the returned events to have time greater equal to. If not given, the (begin of the) current day is used.
     * @param toDate Restricts the returned events to have time less equal to the given.
     * @param page Zero based index of the page to return
     * @param size Number of elements to return per page
     * @param sort Property and direction for sorting the results
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public searchSpaGateEvents(query?: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PaginatedSpaGateEventDTO>;
    public searchSpaGateEvents(query?: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PaginatedSpaGateEventDTO>>;
    public searchSpaGateEvents(query?: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PaginatedSpaGateEventDTO>>;
    public searchSpaGateEvents(query?: string, fromDate?: string, toDate?: string, page?: number, size?: number, sort?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'query',
            <any>query,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'fromDate',
            <any>fromDate,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'toDate',
            <any>toDate,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'page',
            <any>page,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'size',
            <any>size,
            QueryParamStyle.Form,
            false,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'sort',
            <any>sort,
            QueryParamStyle.Form,
            false,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (sessionAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('sessionAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/rest/v1/spa/area/events`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PaginatedSpaGateEventDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
